// extracted by mini-css-extract-plugin
export default {"actionBtns":"Reports_actionBtns__-WCA-","reportRow":"Reports_reportRow__ndyR7"};